import { __extends } from "tslib";
import { Event } from './Event';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: ProgressEvent
var ProgressEvent = /** @class */ (function (_super) {
    __extends(ProgressEvent, _super);
    function ProgressEvent(type, bubbles, cancelable, bytesLoaded, bytesTotal) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (bytesLoaded === void 0) { bytesLoaded = 0; }
        if (bytesTotal === void 0) { bytesTotal = 0; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._bytesLoaded = bytesLoaded;
        _this._bytesTotal = bytesTotal;
        return _this;
    }
    Object.defineProperty(ProgressEvent.prototype, "bytesLoaded", {
        get: function () {
            return this._bytesLoaded;
        },
        set: function (value) {
            this._bytesLoaded = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProgressEvent.prototype, "bytesTotal", {
        get: function () {
            return this._bytesTotal;
        },
        set: function (value) {
            this._bytesTotal = value;
        },
        enumerable: false,
        configurable: true
    });
    ProgressEvent.prototype.clone = function () {
        return new ProgressEvent(this._type, this._bubbles, this._cancelable, this._bytesLoaded, this._bytesTotal);
    };
    ProgressEvent.prototype.toString = function () {
        return this.formatToString('ProgressEvent', 'bubbles', 'cancelable', 'eventPhase', 'bytesLoaded', 'bytesTotal');
    };
    ProgressEvent.classInitializer = null;
    ProgressEvent.classSymbols = null;
    ProgressEvent.instanceSymbols = null;
    // JS -> AS Bindings
    ProgressEvent.PROGRESS = 'progress';
    ProgressEvent.SOCKET_DATA = 'socketData';
    return ProgressEvent;
}(Event));
export { ProgressEvent };
